export type CubicBezierEasing = readonly [number, number, number, number];

export type AnimationEasing = "linear" | CubicBezierEasing;

const BEZIER_ITERATIONS = 32;

const bezierAxis = (t: number, p1: number, p2: number) => 3 * (1 - t) ** 2 * t * p1 + 3 * (1 - t) * t ** 2 * p2 + t ** 3;

export const createCubicBezier = (easing: CubicBezierEasing): ((progress: number) => number) => {
    const [x1, y1, x2, y2] = easing;

    return (progress) => {
        if (progress <= 0) {
            return 0;
        }

        if (progress >= 1) {
            return 1;
        }

        let lower = 0;
        let upper = 1;
        let t = progress;

        for (let iteration = 0; iteration < BEZIER_ITERATIONS; iteration++) {
            const x = bezierAxis(t, x1, x2);

            if (x < progress) {
                lower = t;
            } else {
                upper = t;
            }

            t = (lower + upper) / 2;
        }

        return bezierAxis(t, y1, y2);
    };
};

export const createEasingFunction = (easing: AnimationEasing): ((progress: number) => number) =>
    easing === "linear" ? (progress: number) => progress : createCubicBezier(easing);
export type CubicBezierEasing = readonly [number, number, number, number];

export type AnimationEasing = "linear" | CubicBezierEasing;

const BEZIER_ITERATIONS = 32;

const bezierAxis = (t: number, p1: number, p2: number) => 3 * (1 - t) ** 2 * t * p1 + 3 * (1 - t) * t ** 2 * p2 + t ** 3;

export const createCubicBezier = (easing: CubicBezierEasing): ((progress: number) => number) => {
    const [x1, y1, x2, y2] = easing;

    return (progress) => {
        if (progress <= 0) {
            return 0;
        }

        if (progress >= 1) {
            return 1;
        }

        let lower = 0;
        let upper = 1;
        let t = progress;

        for (let iteration = 0; iteration < BEZIER_ITERATIONS; iteration++) {
            const x = bezierAxis(t, x1, x2);

            if (x < progress) {
                lower = t;
            } else {
                upper = t;
            }

            t = (lower + upper) / 2;
        }

        return bezierAxis(t, y1, y2);
    };
};

export const createEasingFunction = (easing: AnimationEasing): ((progress: number) => number) =>
    easing === "linear" ? (progress: number) => progress : createCubicBezier(easing);
